import { html as beautifyHtml } from "js-beautify";

export const useFormatHtml = () => {
  const customFormatHtml = (html: string) => {
    return beautifyHtml(html, {
      indent_size: 4,
      wrap_line_length: 80,
      unformatted: [],
      content_unformatted: []
    });
  };

  return { customFormatHtml };
};
